import { useState } from "react";
import "./Services.css";

const services = [
  {
    icon: "🦷",
    title: "Dental Implants",
    desc: "Permanent, natural-looking tooth replacements using titanium implants. Restore your smile and confidence with our advanced implant solutions.",
    tag: "Most Popular",
  },
  {
    icon: "✨",
    title: "Cosmetic Dentistry",
    desc: "Complete smile transformations — from teeth whitening and veneers to full makeovers using the latest cosmetic techniques.",
    tag: "",
  },
  {
    icon: "🔬",
    title: "Root Canal Treatment",
    desc: "Painless, precise root canal therapy by specialists. Save your natural tooth and eliminate infection with our gentle approach.",
    tag: "Specialist Care",
  },
  {
    icon: "🧹",
    title: "Teeth Cleaning & Hygiene",
    desc: "Professional scaling, polishing, and deep cleaning to maintain optimal oral health and prevent gum disease.",
    tag: "",
  },
  {
    icon: "🔲",
    title: "Dental Braces & Aligners",
    desc: "Straighten your teeth with metal braces or clear aligners. Modern orthodontic solutions for all ages.",
    tag: "",
  },
  {
    icon: "🏥",
    title: "Oral Surgery",
    desc: "Complex extractions, wisdom teeth removal, and oral surgeries performed with precision, comfort, and care.",
    tag: "",
  },
];

export default function Services() {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="services" id="services">
      <div className="services-inner">
        <div className="services-header">
          <div>
            <span className="section-tag">What We Offer</span>
            <h2 className="section-title">Comprehensive Dental<br />Services</h2>
          </div>
          <p className="section-subtitle">
            Our wide range of dental services is designed to address every aspect of your oral health — from routine care to advanced procedures.
          </p>
        </div>

        <div className="services-grid">
          {services.map((s, i) => (
            <div
              key={s.title}
              className={`service-card ${hovered === i ? "hovered" : ""}`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              {s.tag && <span className="service-tag">{s.tag}</span>}
              <div className="service-icon">{s.icon}</div>
              <h3 className="service-title">{s.title}</h3>
              <p className="service-desc">{s.desc}</p>
              <a href="#contact" className="service-link">
                Learn More
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}